import api from '@/api';
import Vue from "vue";
import { Message } from 'element-ui'
import redmine from './redmine';
import sysInit from './sysInit';
import moment from 'moment';
var sd = require("silly-datetime");
const _ = require('lodash');
import momentTimezone from 'moment-timezone'
import { omit } from 'lodash';

const state  = {
 svTalkDiaLogVisible:false,
 sv_help_isBlingFlg:false,
 sv_help_isBlingFlg_list:[],
 sv_help_onSupportFlg:false,
 sv_help_onSupport_DiaLogVisible:false,
 sv_helper_info:{
   svName: "",
   svExtension: ""
 },

 chat_current_customer_status:"",
 chat_sv_helper_info_list: [],
 chat_sv_name:"",
 sv_help_phone_end:false,
 phone_sv_help_status:"",
//  chat_sv_svExtension:"",
svTalkMessageList:[],
svTalkMessageList_key:0,
svTalkSvName:"",
isSvTalkBlingFlg:false

}
const getters = {
}
const actions = {

  svHelpRequest_phone_f2f(context,item){
    let params = {
      operatorId: sysInit.state.user_id,
      modeName: sysInit.state.ws_mode,
    }

    api.svHelpRequest_phone_f2f(params).then((res)=>{
      console.log(res);
      state. sv_help_isBlingFlg = true;
    }),(err)=>{
      console.log(err)
    }
  },

  svHelpRequest_chat(context,item){
    let params = {
      operatorId: sysInit.state.user_id,
      modeName: sysInit.state.ws_mode,
      customerId:sysInit.state.manualChatQuestionerId
    }

    if( sysInit.state.user_id && sysInit.state.ws_mode && sysInit.state.manualChatQuestionerId){
      api.svHelpRequest_chat(params).then((res)=>{
        console.log(res);
        state.sv_help_isBlingFlg = true;
        let data = {
          questioner_id : sysInit.state.manualChatQuestionerId,
        }
        state.sv_help_isBlingFlg_list.push(data);
      }),(err)=>{
        console.log(err)
      }
    }
  
  },

  svTalkSendMessage(context,item){

    let params = {
    userId:sysInit.state.user_id,
    customerId:sysInit.state.manualChatQuestionerId,
    message:item.message,
    type:"opInnerChat",
    supervisorId:item.supervisorId,
    }

    api.svTalkApi(params).then((res)=>{
      console.log(res);
    }),
    (err)=>{
      console.log(err);
    }
  }

}
const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  